import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { env } from '@/config/env'
import { executionsApi } from '@/lib/api'
import { queryKeys } from '@/lib/queryClient'

/**
 * New execution activity for the signed-in user.
 *
 * Polled on the same interval as the status cluster, so the badge moves while the user is
 * on Chat without anything new in the architecture — no socket, no second event stream. A
 * chat turn also invalidates this key the moment it ends, so in the case that actually
 * matters the badge updates immediately rather than on the next tick.
 */
export function useUnseenExecutions() {
  return useQuery({
    queryKey: queryKeys.unseenExecutions,
    queryFn: executionsApi.unseen,
    refetchInterval: env.pollIntervalMs,
    staleTime: env.pollIntervalMs / 2,
  })
}

/** Mark the activity read, which is what opening the Executions page means. */
export function useMarkExecutionsSeen() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: executionsApi.markSeen,
    onSuccess: () => {
      queryClient.setQueryData(queryKeys.unseenExecutions, { count: 0 })
    },
  })
}
